<template>
  <div v-show="isShowingNoti" id="crown-noti" style="cursor: pointer" @click="onClick()">
    <div id="crown-noti-container" style="position: absolute; top: -70px; right: -70px;" />
    <p v-if="isShowingTitle" id="crown-noti-title" style="position: absolute; top: 0px; right: 3px; color: white; font-size: 12pt; width: 290px; height: 20px; text-align: center; display: block; font-weight: bold;">{{ title }}</p>
    <p v-if="isShowingAmount" id="crown-noti-counter" style="position: absolute; top: 20px; right: 80px; color: white; font-size: 26pt; width: 140px; text-align: center; display: block;">{{ amount }}</p>
    <p v-if="isShowingInfo" id="crown-noti-info" style="position: absolute; top: 130px; right: 13px; color: white; font-size: 10pt; width: 270px; text-align: center; background: #1D1F2C; padding-bottom: 10px;">{{ info }}</p>
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import { NotificationMixin } from '../../../mixins/notification';
import { EventBus, SHOW_MODAL_LOGIN } from '../../../event-bus';
import Vue from 'vue';

export default {
  mixins: [component, NotificationMixin],
  props: {
    amount: {
      type: Number,
      default: 0,
    },
    notification: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: '',
      info: '',
      crownNotiAnimation: null,
      isShowingAmount: false,
      isShowingInfo: false,
      isShowingTitle: false,
      isShowingNoti: false,
    };
  },
  watch: {
    notification: function(newVal, oldVal) {
      if (newVal) {
        Vue.nextTick(() => {
          this.init();
        });
      }
    },
  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    init() {
      const action = this.notification.split('#');
      const eventTitle = action[4];

      this.title = this.getAnimationTitleUserReward(action[0]);
      this.title = this.title.replace('__NAME__', eventTitle);

      this.info = this.getTextUserRewardForQuest(action[0], this.ANIMATION_TYPES.CROWN, this.amount, eventTitle);
      this.info = this.info.replace('__NAME__', eventTitle);
    },
    initAnimation() {
      this.isShowingNoti = false;
      const urlSpriteSheet = this.contentCloudFront('/assets/spritesheet');
      // eslint-disable-next-line no-undef
      this.crownNotiAnimation = createSpriteAnimation({
        pngPath: `${urlSpriteSheet}/notificationcrown-v1.02.png`,
        jsonPath: `${urlSpriteSheet}/notificationcrown-v1.02.json`,
        frameRate: 35,
        id: 'notificationcrown',
        containerId: 'crown-noti-container',
        autoPlay: false,
      });
      this.crownNotiAnimation.boundingBox = { w: 450, h: 350 };
    },
    onClick() {
      if (this.notification.includes('GuestFeature')) {
        EventBus.$emit(SHOW_MODAL_LOGIN, '', '', true);
      } else {
        const currentLink = window.location.href;
        if (!currentLink.includes(this.routeDropsPage())) {
          window.location.href = this.routeDropsPage();
        }
      }
    },
    playAnimation(callback) {
      this.isShowingNoti = false;
      this.isShowingTitle = false;
      this.isShowingAmount = false;
      this.isShowingInfo = false;

      // eslint-disable-next-line no-undef
      const animationQueue = new SpriteAnimationQueue(this.crownNotiAnimation, () => {
        this.isShowingNoti = false;
        this.isShowingTitle = false;
        this.isShowingAmount = false;
        this.isShowingInfo = false;

        if (callback) {
          callback();
        }
      });
      animationQueue.push(0, 10, () => {
        this.isShowingNoti = true;
        this.isShowingTitle = true;
        this.isShowingAmount = true;
        this.isShowingInfo = true;
      });
      /**
                 * Loop to add extra delay
                 */
      animationQueue.push(60, 120);
      // animationQueue.push(60, 120);
      // animationQueue.push(60, 120);
      // animationQueue.push(60, 120);
      // animationQueue.push(60, 120);

      animationQueue.push(60, 164, function() {
        this.isShowingNoti = false;
        this.isShowingTitle = false;
        this.isShowingAmount = false;
        this.isShowingInfo = false;
      });
      animationQueue.push(165);
      animationQueue.play();
    },
  },
};
</script>
